import { render, staticRenderFns } from "./uusi-teoriakoulutus.vue?vue&type=template&id=d7935a84&scoped=true&"
import script from "./uusi-teoriakoulutus.vue?vue&type=script&lang=ts&"
export * from "./uusi-teoriakoulutus.vue?vue&type=script&lang=ts&"
import style0 from "./uusi-teoriakoulutus.vue?vue&type=style&index=0&id=d7935a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7935a84",
  null
  
)

export default component.exports